import PropTypes from "prop-types";

export const minChars = charMin => string => string.trim().length >= charMin;

export const noDigits = string => {
    const containsDigits = str => /\d/.test(str);
    return !containsDigits(string);
};

export const nameFieldValidation = [
    {
        isValid: minChars(1),
        errorMsg: "Please enter a billing name."
    },
    {
        isValid: noDigits,
        errorMsg: "Name cannot contain numerals"
    }
];

export const PhotoCheckoutPropTypes = PropTypes.shape({
    cancelLink: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired,
    hasSavedCard: PropTypes.bool.isRequired,
    isPhotoCheckout: PropTypes.bool.isRequired,
    isSubmitDisabled: PropTypes.bool.isRequired,
    itemPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    licenseSchemas: PropTypes.array.isRequired,
    licenseSelection: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onCheckoutPath: PropTypes.bool,
    response: PropTypes.object.isRequired,
    saveCardCheckboxOnClick: PropTypes.func.isRequired,
    saveCardInitialValue: PropTypes.bool.isRequired,
    showOrderSummary: PropTypes.bool.isRequired,
    showPayPalPayment: PropTypes.bool,
    slugWithId: PropTypes.string.isRequired,
    submitFormWithNewCardInfo: PropTypes.func.isRequired,
    submitFormWithSavedCardInfo: PropTypes.func.isRequired,
    thumbnail: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
});

export const IconCheckoutPropTypes = PropTypes.shape({
    cancelLink: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired,
    hasSavedCard: PropTypes.bool.isRequired,
    hideCardLinks: PropTypes.bool.isRequired,
    isSubmitDisabled: PropTypes.bool.isRequired,
    isSubscription: PropTypes.string.isRequired,
    itemPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    itemPriceOrderSummaryItem: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    itemTitle: PropTypes.string.isRequired,
    licenseSelection: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onCheckoutPath: PropTypes.bool,
    orderSummaryTextLine1: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    orderSummaryTextLine2: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    response: PropTypes.object.isRequired,
    saveCardCheckboxOnClick: PropTypes.func.isRequired,
    saveCardInitialValue: PropTypes.bool.isRequired,
    showPayPalPayment: PropTypes.bool,
    submitFormWithNewCardInfo: PropTypes.func.isRequired,
    submitFormWithSavedCardInfo: PropTypes.func.isRequired,
    thumbnail: PropTypes.string.isRequired
});

export const StandaloneSubscriptionPropTypes = PropTypes.shape({
    cancelLink: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired,
    hasSavedCard: PropTypes.bool.isRequired,
    hideCardLinks: PropTypes.bool.isRequired,
    isSubmitDisabled: PropTypes.bool.isRequired,
    itemPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    licenseSelection: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    numSeats: PropTypes.number.isRequired,
    onCheckoutPath: PropTypes.bool,
    saveCardCheckboxOnClick: PropTypes.func.isRequired,
    saveCardInitialValue: PropTypes.bool.isRequired,
    showPromoCode: PropTypes.bool,
    showPayPalPayment: PropTypes.bool,
    submitFormWithSavedCardInfo: PropTypes.func.isRequired,
    submitText: PropTypes.string.isRequired
});
